const locale = {
  general: {
    language: 'Nederlands',
    cancel: 'Annuleren',
    yes: 'Ja',
    no: 'Nee',
    ok: 'Ok',
    apply: 'Toepassen',
    continue: 'Doorgaan',
    confirm: 'Begrepen',
    save: 'Opslaan',
    close: 'Sluiten',
    loading: 'Even geduld a.u.b. ...',
    errorHeader: 'Fout',
    errorEmptyField: 'Verplicht veld',
    errorEmptyFields: 'Verplicht veld is leeg',
    errorInvalidEmail: 'Ongeldig e-mail',
    successHeader: 'Succes',
    successfullySaved: 'Succesvol opgeslagen',
    successfullyVerified: 'Succesvol geverifieerd',
    errorStampUpload: 'stempel upload fout'
  },
  oneTwoBuildNotifySales: {
    text: '12Build koppeling is nog niet geactiveerd, u kunt deze laten activeren door uw Docstream beheerder.'
  },
  treeView: {
    rootFolderName: 'Kantoor',
    title: 'Folders',
    allFolder: 'Alle mappen',
    favoriteFolder: 'Favoriete mappen',
    newDocs: 'Nieuwe documenten',
    workBox: 'Werkbak',
    newDocsDescription: 'Documenten van afgelopen 7 dagen'
  },
  toolbar: {
    new: 'Nieuw',
    import: 'Document importeren',
    newViaTemplate: 'Nieuw document van sjabloon',
    expected: 'Verwachte documenten',
    newFolder: 'Nieuw map',
    newFolderViaTemplate: 'Nieuw map van sjabloon',
    show: 'Bekijken',
    edit: 'Wijzigen',
    publish: 'Publiceren',
    search: 'Zoeken',
    status: 'Status',
    stamp: 'Stempelen',
    QRCode: 'QR-code',
    message: 'Bericht',
    printOrder: 'Repro opdracht',
    version: 'Versiescherm',
    view: 'Beeld',
    extra: 'Extra'
  },
  mainNav: {
    documents: 'Documenten',
    management: 'Beheer',
    messages: 'Berichten',
    contacts: 'Contacten',
    procedures: 'Procedures'
  },
  login: {
    username: 'Gebruikersnaam',
    usernameWithEmail: 'E-mail',
    password: 'Wachtwoord',
    login: 'Inloggen',
    or: 'of',
    back: 'Terug',
    employeeOf: 'Medewerker van Pro4all',
    portal: 'Pro4all Portal',
    reset: 'Wachtwoord resetten',
    resetText: 'Voer hier je nieuwe wachtwoord in.',
    resetBadPassFirst: 'Het opgegeven wachtwoord is ongeldig. Het wachtwoord mag niet al eerder gebruikt zijn, en moet uit minstens ',
    resetBadPassSecond: ' karakters bestaan, waaronder ',
    resetBadPassThird: ' vreemd karakter (bijvoorbeeld !@#$%^&*).',
    resetDiffer: 'De wachtwoorden komen niet overeen.',
    resetSave: 'Sla op',
    resetNew: 'Nieuw wachtwoord',
    resetConfirm: 'Bevestig wachtwoord',
    resetSuccess: 'Het wachtwoord is ingesteld. Ga terug en log in met je nieuwe wachtwoord.',
    resetFail: 'De link is niet correct of niet meer geldig.',
    forgotPassword: 'Wachtwoord vergeten?',
    forgotPasswordText: 'Voer jouw gebruikersnaam in om een nieuw wachtwoord te ontvangen.',
    forgotPasswordTextWithEmail: 'Voer uw e-mailadres in om een nieuw wachtwoord te ontvangen.',
    forgotPasswordFail: 'Er is geen gebruikersnaam opgegeven.',
    forgotPasswordFailEmail: 'Ongeldig e-mailformaat opgegeven',
    forgotPasswordSuccessFirst: 'Als de opgegeven gebruikersnaam in Docstream bestaat, zou je een e-mail met een link moeten ontvangen waarmee het wachtwoord ingesteld kan worden. Deze actie kan maximaal ',
    forgotPasswordSuccessFirstWithEmail: 'Als het opgegeven e-mailadres in Docstream bestaat, zou u een e-mail moeten ontvangen met een link om het wachtwoord in te stellen. Deze actie is maximaal',
    forgotPasswordSuccessSecond: ' keer per dag uitgevoerd worden.',
    forgotPasswordSuccessTimeFirst: 'Let op: de toegestuurde link is ',
    forgotPasswordSuccessTimeSecond: ' minuten geldig.',
    expired: 'Uw sessie is verlopen.',
    expiredText: 'Uw sessie is verlopen wegens uw inactiviteit in docstream. Klik op onderstaande knop om opnieuw in te loggen.',
    doubleLogin: 'Gebruikersnaam al ingelogd!',
    doubleLoginFirstHeader: 'Oorzaak:',
    doubleLoginFirstText: 'De oorzaak van deze melding is als je op een andere computer al bent ingelogd met dezelfde gebruikersgegevens.',
    doubleLoginSecondHeader: 'Oplossing:',
    doubleLoginSecondText: 'Sla eerst je werk op de andere computer op, meld je daar vervolgens af en log dan opnieuw in.',
    wrongLoginTitle: 'Inloggen is niet gelukt',
    wrongLogin: 'Controleer gegevens en probeer nog een keer',
    wrongEmailFormat: 'Ongeldige email formaat',
    wrongEmail: 'Voer een geldig e-mailadres in',
    loginRequestError: 'Er was een probleem met inloggen',
    introText: 'Beheer al je projecten en documenten op één overzichtelijke plek',
    send: 'Stuur e-mail',
    loggedOut: 'Je bent uitgelogd.',
    loggedOutText: 'Je bent uitgelogd uit docstream. Klik op onderstaande knop om opnieuw in te loggen.',
    OIDCErrorHeader: 'Inloggen niet gelukt',
    OIDCErrorFirstText: 'Het is niet gelukt om jou via een extern account in te loggen. Mogelijk heb je geen extern account ingesteld.',
    OIDCErrorSecondText: 'Log hiervoor eerst met je Docstream inloggegevens en stel daar een extern account in via [Extra -> Extern account].',
    mfaTitle: 'Verifieer je account',
    mfaDescription: 'Je vindt de tweestapsverificatie code in de authenticatie app.',
    mfaPlaceholder: 'Code opgeven',
    mfaButton: 'Inloggen',
    mfaTitleSetup: 'Verifieer je account',
    mfaDescriptionSetup: 'Open de authenticatie-app op je smartphone.',
    mfaTitleSetup2: 'Scannen maar',
    mfaDescriptionSetup2: 'Scan de QR-code in de authenticatie-app op je smartphone.',
    mfaTitleSetup3: 'Vul de code in',
    mfaDescriptionSetup3: 'Vul hier de zes cijfers in die verschijnen in de authenticatie-app.',
    mfaDescriptionCode: 'Gebruik handmatig de volgende code:',
    mfaButtonSetup: 'Bevestig code'
  },
  loginCarousel: {
    slideTitle: 'Maak kennis met Prostream',
    slideText: 'De nieuwste manier om documenten en projecten te managen. {slideLinkText} voor meer informatie.',
    slideLinkText: 'Klik hier'
  },
  newFolder: {
    title: 'Nieuwe map aanmaken',
    subTitle: 'Mapnaam',
    inputText: 'Mapnaam opgeven',
    cancelButton: 'Annuleren',
    acceptButton: 'Ok',
    errorMessage: 'De mapnaam moet minimaal 1 teken bevatten en mag maximaal 255 tekens bevatten en gebruik geen karakters zoals: \\/:*?"<>|.'
  },
  usersInformation: {
    headerTitle: 'Gebruikersinformatie',
    tabs: {
      title: 'Instellingen',
      general: 'Algemeen',
      personalInformation: 'Persoonlijke gegevens',
      companyInformation: 'Zakelijke gegevens',
      signature: 'Handtekening',
      verify: '2 factor authentication',
      stamp: 'Stempelen'
    },
    buttons: {
      close: 'Annuleren',
      save: 'Opslaan'
    },
    general: {
      title: 'Algemeen',
      text: 'Vul hier je algemene instellingen in en aan. Let op, alle aanpassingen hebben invloed op de hele omgeving.',
      username: 'Gebruikersnaam',
      name: 'Naam',
      email: 'E-mailadres',
      toInform: 'Informeren',
      dropdownPlaceholder: 'Optie selecteren...',
      dropdownOptions: ['Ja, over alles', 'Ja, per map', 'Nee', 'Ja, per favoriete map'],
      description: 'Beschrijving',
      password: 'Wachtwoord',
      confirmPassword: 'Bevestig wachtwoord',
      passwordChange: 'Aanpassen',
      resetEmail: 'Stuur reset e-mail'
    },
    personal: {
      title: 'Persoonlijke gegevens',
      text: 'Vul hier je algemene instellingen in en aan. Let op, alle aanpassingen hebben invloed op de hele omgeving.',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      prefixes: 'Tussenvoegsel',
      email: 'E-mailadres',
      workphone: 'Werknummer',
      mobile: 'Mobiele nummer',
      checkbox: 'Ik wil de nieuwsbrief ontvangen'
    },
    company: {
      title: 'Zakelijke gegevens',
      text: 'Vul hier je algemene instellingen in en aan. Let op, alle aanpassingen hebben invloed op de hele omgeving.',
      name: 'Bedrijfsnaam',
      function: 'Functie'
    },
    signature: {
      title: 'Handtekening',
      text: 'Je handtekening wordt gebruikt in alle mailcorrespondentie.'
    },
    verify: {
      title: '2 factor authentication',
      text1: 'Scan de QR-code via een ‘two factor authentication App’ om je account veiliger te maken. Wanneer je ergens inlogt moet je de code via de App die je koppelt gebruiken om te bevestigen dat jij ook wilt inloggen.',
      text2: 'Eenmaal gescand wordt er een code weergeven. Vul deze hieronder om de ‘two factor authentication’ app te koppelen.',
      disabledText: 'De 2 factor authenticatie is al geactiveerd. Je kan deze deactiveren of de TOIP code ophalen om je account te delen of aan een ‘password vault’ toevoegen.',
      confirm: 'Bevestig',
      disable: 'deactiveren'
    },
    stamp: {
      title: 'Stempelen',
      text: 'Toevoegen Stempelen',
      noImage: 'Geen afbeelding',
      upload: 'uploaden',
      fileExtension: 'Alleen .PNG afbeeldingen kunnen gebruikt worden als stempel.'
    }
  },
  folderProperties: {
    general: {
      title: 'Algemeen',
      form: {
        label1: 'Mapnaam',
        label2: 'Map aangemaakt door',
        label3: 'Map aangemaakt op',
        label4: 'Map inhoud',
        label5: 'Metadata set',
        label6: 'Project',
        label7: 'Snagstream project',
        notLinked: 'Niet gekoppeld',
        checkbox1: 'Project map',
        checkbox2: 'Vertrouwelijke map',
        unlinkButton: 'Ontkoppelen'
      }
    },
    procedure: {
      title: 'Procedure',
      form: {
        checkbox: 'Automatisch een nieuwe procedure starten bij het plaatsen van een document(versie)',
        label1: 'Standaard',
        label2: 'Eigenaar'
      }
    },
    requiredDocuments: {
      title: 'Vereiste documenten',
      form: {
        label: {
          line1: 'Vul hieronder de vereiste documentnamen in van deze map',
          line2: '(Iedere naam op een nieuwe regel)'
        },
        textareaPlaceholder: ''
      }
    }
  },
  folderRights: {
    header: {
      title: 'Rechten op',
      searchPlaceholder: 'Zoeken…'
    },
    table: {
      header: {
        Name: {
          title: 'Naam',
          bodyTitle: 'Informatie',
          bodyText: [
            'Sommige rechten hebben twee kolommen, hieronder staat beschreven wat deze inhouden.',
            'De eerste kolom houdt het betreffende recht in voor de huidige map.',
            'De tweede kolom geeft aan dat het betreffende recht ook op submappen geldt.'
          ]
        },
        IL: {
          bodyTitle: 'Intern lezer',
          bodyText: [
            'Alle documenten zijn zichtbaar, ongeacht de status van het document.'
          ]
        },
        EL: {
          bodyTitle: 'Extern lezer',
          bodyText: [
            'Documenten met de status \'Goedkeuren\' zijn zichtbaar.'
          ]
        },
        DL: {
          bodyTitle: 'Definitief lezer',
          bodyText: [
            'Documenten die zowel \'Goedkeuren\' en \'Bevriezen\' statussen hebben zijn zichtbaar.'
          ]
        },
        ET: {
          bodyTitle: 'Extern teamlid',
          bodyText: [
            'Documenten met de status \'Goedkeuren\' zijn zichtbaar.',
            'Documenten waarvan u zelf de auteur bent zijn zichtbaar.',
            'U kunt nieuwe documenten plaatsen.',
            'U kunt nieuwe versies onder uw eigen documenten plaatsen.',
            'U kunt documenten de status \'Goedkeuren\' geven of deze opheffen.',
            'U kunt alleen eigen documenten verwijderen.'
          ]
        },
        A: {
          bodyTitle: 'Assistent',
          bodyText: [
            'Alle documenten zijn zichtbaar, ongeacht de status van het document.',
            'U kunt nieuwe documenten plaatsen.',
            'U kunt nieuwe versies onder documenten plaatsen.',
            'U kunt alleen eigen documenten verwijderen.'
          ]
        },
        IT: {
          bodyTitle: 'Intern teamlid',
          bodyText: [
            'Alle documenten zijn zichtbaar, ongeacht de status van het document.',
            'U kunt nieuwe documenten plaatsen.',
            'U kunt documenten verwijderen.',
            'U kunt nieuwe versies onder documenten plaatsen.',
            'U kunt documenten de status \'Goedkeuren\' geven of deze opheffen.'
          ]
        },
        '+': {
          bodyTitle: 'Submappen aanmaken',
          bodyText: [
            'U kunt onder deze map nieuwe mappen aanmaken.'
          ]
        },
        EV: {
          bodyTitle: 'Eindverantwoordelijke',
          bodyText: [
            'U kunt documenten de status \'Bevriezen\' geven of deze opheffen.'
          ]
        },
        B: {
          bodyTitle: 'Beheerder',
          bodyText: [
            'Alle documenten zijn zichtbaar, ongeacht de status van het document.'
          ]
        },
        PB: {
          bodyTitle: 'Postboek beheerder',
          bodyText: [
            'U bent postboekbeheerder.'
          ]
        },
        PC: {
          bodyTitle: 'Proces coordinator',
          bodyText: [
            'U kunt procedures aan documenten koppelen.'
          ]
        },
        I: {
          bodyTitle: 'Informeren',
          bodyText: [
            'Hier kan de mailnotificatie worden aangezet voor de huidige en onderliggende mappen.'
          ]
        },
        Alternative: {
          EL: {
            bodyText: 'Documenten met de status \'{0}\' zijn zichtbaar.'
          },
          DL: {
            bodyText: 'Documenten die zowel \'{0}\' en \'{1}\' statussen hebben zijn zichtbaar.'
          },
          ET: {
            bodyText1: 'Documenten met de status \'{0}\' zijn zichtbaar.',
            bodyText2: 'Documenten waarvan u zelf de auteur bent zijn zichtbaar.',
            bodyText3: 'U kunt nieuwe documenten plaatsen.',
            bodyText4: 'U kunt nieuwe versies onder uw eigen documenten plaatsen.',
            bodyText5: 'U kunt documenten de status \'{0}\' geven of deze opheffen.',
            bodyText6: 'U kunt alleen eigen documenten verwijderen.'
          },
          IT: {
            bodyText1: 'Alle documenten zijn zichtbaar, ongeacht de status van het document.',
            bodyText2: 'U kunt nieuwe documenten plaatsen.',
            bodyText3: 'U kunt documenten verwijderen.',
            bodyText4: 'U kunt nieuwe versies onder documenten plaatsen.',
            bodyText5: 'U kunt documenten de status \'{0}\' geven of deze opheffen.'
          },
          EV: {
            bodyText: 'U kunt documenten de status \'{0}\' geven of deze opheffen.'
          },
          Default: 'Goedkeuren',
          DefaultFinal: 'Bevriezen'
        }
      }
    },
    buttons: {
      cancel: 'Annuleer',
      exchange: 'Inwisselen',
      modify: 'Wijzigen',
      close: 'Sluiten',
      save: 'Opslaan',
      removeAll: 'Verwijder alles'
    }
  },
  CommentDialog: {
    downloadAttachmentTitle: '{0} attachments',
    closeButtonText: 'Close',
    downloadButton: 'Download ({0})',
    errorMessage: 'The files you requested are not available or you do not have access to them'
  },
  DocumentGrid: {
    noOptionsAvailable: 'No options available',
    EmptyFolder: 'No documents available',
    DocumentNotLoaded: 'Unable to retrieve documents',
    searchingFilters: 'Filters zoeken',
    selectedDocuments: '({0} document(en) geselecteerd)',
    checkVersionError: 'Unable to check selected versions',
    loadingGridMessage: 'Bezig met laden',
    LoadingErrorMessage: 'The current page could not be loaded, try again later or report the error',
    ApplyFilter: 'Filter toepassen',
    RemoveFilters: 'Verwijder filter',
    SearchAllFolders: 'zoeken in alle mappen',
    ascending: 'Oplopend',
    descending: 'Aflopend',
    facetFilter: 'Zoek...',
    selectAll: 'Alles selecteren',
    deSelectAll: 'Alles deselecteren'
  }
}

export default locale



// WEBPACK FOOTER //
// ./src/localization/locales/nl.js